import { Divider } from 'ui-kit/divider'
import { BG_COLOR } from 'views/stats/constants'

import { ActionCard, Row, StatCard, TopBottomKeysWrapper } from './top-bottom-keys.styles'

export type TopBottomCategories = 'uppercase' | 'lowercase' | 'num' | 'punctuation'

export type SingleTopBottomItem = {
  statCategory: string
  letter: string
  stat: number
}

export type TopBottomStats = {
  top: SingleTopBottomItem[]
  bottom: SingleTopBottomItem[]
}

export interface TopBottomKeysProps {
  speed: TopBottomStats
  accuracy: TopBottomStats
  handleGenerateLesson?: (characters: string[]) => void
}

export const TopBottomKeys = (props: TopBottomKeysProps) => {
  const { speed, accuracy, handleGenerateLesson } = props

  const noData =
    speed.top.length === 0 && speed.bottom.length === 0 && accuracy.top.length === 0 && accuracy.bottom.length === 0

  if (noData) return null

  return (
    <TopBottomKeysWrapper>
      <Row>
        <ActionCard success={true}>
          <div>Highest</div>
          <div>WPM</div>
          {handleGenerateLesson && (
            <div onClick={() => handleGenerateLesson(speed.top.map((el) => el.letter))}>Generate lesson</div>
          )}
        </ActionCard>

        {speed.top.slice(0, 5).map((obj, index) => (
          <StatCard key={index} bg={BG_COLOR[obj.statCategory as TopBottomCategories]}>
            <div>{obj.letter}</div>
            <div>{obj.stat}</div>
          </StatCard>
        ))}
      </Row>
      <Row>
        <ActionCard success={true}>
          <div>Highest</div>
          <div>Accuracy</div>
          {handleGenerateLesson && (
            <div onClick={() => handleGenerateLesson(accuracy.top.map((el) => el.letter))}>Generate lesson</div>
          )}
        </ActionCard>
        {accuracy.top.slice(0, 5).map((obj, index) => (
          <StatCard key={index} bg={BG_COLOR[obj.statCategory as TopBottomCategories]}>
            <div>{obj.letter}</div>
            <div>{obj.stat}</div>
          </StatCard>
        ))}
      </Row>

      <Divider color="#dbdbdb" length="580px" wrapperThickness="4rem" />

      <Row>
        <ActionCard>
          <div>Lowest</div>
          <div>WPM</div>
          {handleGenerateLesson && (
            <div onClick={() => handleGenerateLesson(speed.bottom.map((el) => el.letter))}>Generate lesson</div>
          )}
        </ActionCard>
        {speed.bottom.slice(0, 5).map((obj, index) => (
          <StatCard key={index} bg={BG_COLOR[obj.statCategory as TopBottomCategories]}>
            <div>{obj.letter}</div>
            <div>{obj.stat}</div>
          </StatCard>
        ))}
      </Row>
      <Row>
        <ActionCard>
          <div>Lowest</div>
          <div>Accuracy</div>
          {handleGenerateLesson && (
            <div onClick={() => handleGenerateLesson(accuracy.bottom.map((el) => el.letter))}>Generate lesson</div>
          )}
        </ActionCard>
        {accuracy.bottom.slice(0, 5).map((obj, index) => (
          <StatCard key={index} bg={BG_COLOR[obj.statCategory as TopBottomCategories]}>
            <div>{obj.letter}</div>
            <div>{obj.stat}</div>
          </StatCard>
        ))}
      </Row>
    </TopBottomKeysWrapper>
  )
}
